//接口管理
import http from '../utils/request';

//官网api
let api = {
  // 获取首页数据
  getIndex: () => http.get(`portal/home`),
  //获取资讯列表
  getArticleList: (page=1,rows=10,type) => http.get(`portal/article?page=${page}&rows=${rows}&type=${type}`),
  // 获取资讯详情
  getArticleDetails: (id) => http.get(`portal/article/${id}`),
  // 获取产品分类下的所有商品
  getCatalogProduct: (id) => http.get(`portal/catalog/${id}`)
}

export default api



// WEBPACK FOOTER //
// ./src/api/api.js